export default function getRelativeUrl(absoluteUrl: string): string {
    const url = new URL(absoluteUrl, window.location.href);
    return url.pathname + url.search + url.hash;
}
